import { Button } from '@heroui/react'
import React from 'react'
import PropTypes from 'prop-types'

function CoursesCard({ alignment, imageUrl, alt, title, description, enrollHandler, viewMoreHandler }) {
    return (
        <div className="flex flex-col lg:flex-row items-center p-8 gap-x-8">
            {/* description part */}
            <div className={`lg:w-1/2 order-1 ${alignment === 'left' ? 'lg:order-2' : 'lg:order-1'}`}>
                <div className="bg-primary-blue rounded-tr-lg rounded-bl-lg text-white py-2 px-4 w-fit xl:text-2xl">{title}</div>
                <p className='text-justify mt-5'>
                    {/* if theres description */}
                    {description}
                </p>
                <div className='mt-5'>
                    <Button radius='sm' className='bg-primary-blue text-white' onPress={enrollHandler}>Enroll Now</Button>
                    {/* <Button radius='sm' className='text-primary-blue border-2 ms-2'
                        variant='outlined' onPress={viewMoreHandler}
                    >View More</Button> */}
                </div>
            </div>

            {/* img container */}
            <div className={`relative h-[300px] sm:h-[340px] lg:h-[380px] w-full lg:w-1/2 rounded-xl overflow-hidden mt-8 lg:mt-0 order-2 ${alignment === 'left' ? 'lg:order-1' : 'lg:order-2'}`}>
                <img src={imageUrl || 'https://developers.elementor.com/docs/assets/img/elementor-placeholder-image.png'} alt={alt} className="absolute inset-0 w-full h-full object-cover z-10" />
            </div>
        </div>
    );
}

// prop types
CoursesCard.propTypes = {
    alignment: PropTypes.oneOf(["right", "left"]),
    imageUrl: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    enrollHandler: PropTypes.func,
    viewMoreHandler: PropTypes.func
};

export default CoursesCard;
